import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { DatePicker } from '@mui/x-date-pickers';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { addDays, isValid, startOfDay, subMonths } from 'date-fns';
import { TablePagination } from '@mui/material';
import LoadingSpinner from '../ui/LoadingSpinner';
import CustomerAppAuditList from './CustomerAppAuditList';
import SearchFieldNarrow from '../ui/SearchFieldNarrow';
import AppBindStyles from '../../AppBindStyles';

const abEnvironment = new AbEnvironment();
const CustomerAppAuditQuery = graphql`
query CustomerAppAuditQuery($startDate: Datetime, $endDate: Datetime, $customerAppId: UUID!, $auditDetail: String, $changeByAccount: String, $changedByEmail: String, $auditType: Int, $orderBy: Int, $direction: Int, $first: Int, $offset: Int) {
  customerappauditsearch(startts: $startDate, endts: $endDate, customerappid: $customerAppId, auditdetail: $auditDetail, changebyaccount: $changeByAccount, changedbyemail: $changedByEmail, audittype: $auditType, orderby: $orderBy, direction: $direction, first: $first, offset: $offset) {
    totalCount
    ...CustomerAppAuditList_al
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      //marginTop: 10,
    },
    flex: {
      flex: 1,
    },
    type: {
      width: 124
    },
    typeSelector: {
      width: 124,
    },
    textField: {
      width: 160,
    }
});

class CustomerAppAudit extends Component {

    constructor(props) {
      super(props);
   
      // Default toDate
      let cToDate = new Date();
      let tDate = localStorage.getItem('custAuditToDate');
      if (tDate != null) {
        cToDate = new Date(tDate);
      }
      //search "to date" for query is start of next day
      let searchToDateUtc = startOfDay(addDays(cToDate, 1)).toISOString();
  
      let cFromDate = new Date();
      let fDate = localStorage.getItem('custAuditFromDate');
      if (fDate != null) {
        cFromDate = new Date(fDate);
      } else {
        cFromDate = subMonths(cToDate, 1);
      }
      //search "from date" is start of selected day
      let searchFromDateUtc = startOfDay(cFromDate).toISOString();
  
      this.state = {
        startDate: cFromDate,
        queryStartDateUtc: searchFromDateUtc,
        endDate: cToDate,
        queryEndDateUtc: searchToDateUtc,
        subject: '',
        changedByAccountName: '', 
        changedByEmail: '',
        forwardingEmail: '',
        auditType: -1,
        page: 0,
        rowsPerPage: 10
      };  
    }

    handleChange = name => event => {
      this.setState({
        [name]: event.target.value,
        page: 0,
      });
    };

    setFromDate(theDate) {
      let vdate = new Date(theDate);
      if (isValid(vdate)) {
        localStorage.setItem('custAuditFromDate', vdate);
        let searchDateUtc = startOfDay(vdate).toISOString();
        this.setState({ startDate: vdate, queryStartDateUtc: searchDateUtc, page: 0 });
      }
    }
  
    setToDate(theDate) {
      let vdate =new Date(theDate);
      if (isValid(vdate)) {
        localStorage.setItem('custAuditToDate', vdate);
        let searchDateUtc = startOfDay(addDays(vdate, 1)).toISOString();
        this.setState({ endDate: vdate, queryEndDateUtc: searchDateUtc, page: 0 });
      }
    }
      
    handleChangePage = (event, page) => {
      this.setState({page: page});
    }
    
    handleChangeRowsPerPage = (event) => {
      this.setState({ rowsPerPage: event.target.value, page : 0});
    }
  
    render() {

      const { isAuthenticatedCustomer } = this.props.auth;
      const classes = this.props.classes;
    
      let theSubjectSearch = null;
      if (this.state.subject !== null)
      {
        theSubjectSearch = '%' + this.state.subject + '%';
      }
      let theChangedByAccountSearch = null;
      if (this.state.changedByAccountName !== '') {
        theChangedByAccountSearch = '%' + this.state.changedByAccountName + '%';
      } 
      let theChangedByEmailSearch = null;
      if (this.state.changedByEmail !== '')
      {
        theChangedByEmailSearch = '%' + this.state.changedByEmail + '%';
      }


      // Determine the offset
      let offset = 0;
      if (this.state.page > 0)
      {
        offset = this.state.page * this.state.rowsPerPage
      }
      let first = this.state.rowsPerPage;
    
      let totalCount = 0;

      return (
        <div className={classes.root}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Typography variant="h6">
                    Subscription history
                  </Typography>
                  <Grid item xs={12}>
                    <Typography variant="body2">Review how this subscription has been shared and managed.</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={2} justifyContent="flex-start">
                <Grid item style={AppBindStyles.datePickerField}>
                  <DatePicker 
                    disableFuture
                    label="From date"
                    value={this.state.startDate}
                    onChange={(newValue) => {
                      this.setFromDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField 
                        {...params}
                        sx={{
                          svg: {paddingRight: '2px'}
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item style={AppBindStyles.datePickerField}>
                  <DatePicker 
                    disableFuture
                    label="To date"
                    value={this.state.endDate}
                    onChange={(newValue) => {
                      this.setToDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField 
                        {...params}
                        sx={{
                          svg: {paddingRight: '2px'}
                        }}
                      />
                    )}
                  />
                </Grid>                
                <Grid item>
                  <FormControl variant="standard"
                    className={classes.typeSelector}
                  >
                    <InputLabel shrink htmlFor="auditType">Type</InputLabel>
                    <Select
                      value={this.state.auditType}
                      inputProps={{
                        name: 'auditType',
                        id: 'auditType',
                      }}
                      onChange={this.handleChange('auditType')}
                      className={classes.type}
                    >
                      <MenuItem value={-1}>Any</MenuItem>
                      <MenuItem value={0}>Created</MenuItem>
                      <MenuItem value={1}>Terms change</MenuItem>
                      <MenuItem value={3}>SO lifecycle</MenuItem>
                      <MenuItem value={4}>Status change</MenuItem>
                      <MenuItem value={6}>Other update</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item>
                  <SearchFieldNarrow
                    id="changedByEmail"
                    label="Changed by"
                    value={this.state.changedByEmail}
                    onChange={this.handleChange('changedByEmail')}
                  />
                </Grid>
                {!isAuthenticatedCustomer() &&
                <Grid item>
                  <SearchFieldNarrow
                    id="changedByAccountName"
                    label="Account name"
                    value={this.state.changedByAccountName}
                    onChange={this.handleChange('changedByAccountName')}
                  />
                </Grid>}
                <Grid item>
                  <SearchFieldNarrow
                    id="Subject"
                    label="Detail"
                    value={this.state.subject}
                    onChange={this.handleChange('subject')}
                  />
                </Grid>


              </Grid>
            </Grid>

            <Grid item xs={12}>
              <QueryRenderer
                environment={abEnvironment.getEnvironment()}
                query={CustomerAppAuditQuery}
                variables={{startDate: this.state.queryStartDateUtc,
                            endDate: this.state.queryEndDateUtc,
                            customerAppId: this.props.customerAppId,
                            auditType: this.state.auditType === -1 ? null : this.state.auditType,
                            auditDetail: theSubjectSearch,
                            changedByEmail: theChangedByEmailSearch,
                            changeByAccount: theChangedByAccountSearch,
                            first: first,
                            offset: offset}}
                render={({error, props})=> {
                  if (error) {
                    return <div>{error.message}</div>
                  } else if (props) {
                    // Determine offset information
                    totalCount = props.customerappauditsearch.totalCount;

                    return (
                      <React.Fragment>
                        <CustomerAppAuditList al={props.customerappauditsearch} history={this.props.history} auth={this.props.auth}/>
                        <div style={AppBindStyles.paginationTableFooter}>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={totalCount}
                            rowsPerPage={this.state.rowsPerPage}
                            page={this.state.page}
                            backIconButtonProps={{
                              'aria-label': 'Previous Page',
                            }}
                            nextIconButtonProps={{
                              'aria-label': 'Next Page',
                            }}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                          />                        
                        </div>
                      </React.Fragment>
                    )
                  }
                  return (
                    <LoadingSpinner />
                  );
                }}
              />
            </Grid>
          </Grid>
        </div>
      );
    }
}
  
CustomerAppAudit.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(CustomerAppAudit);